import React, { useEffect, useState } from 'react'

import Grid from '@mui/material/Grid'
import { Button, FormLabel, IconButton, TextField, makeStyles } from '@material-ui/core'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddIcon from '@material-ui/icons/Add';
import { v4 as uuidv4 } from 'uuid';
import serviceRest from '../../services/serviceRest'
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    formTitle: {
        fontWeight: "bold",
    },
    helperTxt: {
        color: "red"
    }
}));

const AuthorsSelection = ({ authorsList, setAuthorsList, disabled }) => {
    const classes = useStyles();
    const [searchAuthorList, setSearchAuthorList] = useState([]);

    useEffect(() => {
        serviceRest.get('/mediaserver/reservation/searchAuthor').then((response) => {
            setSearchAuthorList(response.data.authorsList)
        }, (error) => {

        });
    }, [])

    

    const handleChange = (event, item, properties) => {

        let index = authorsList.indexOf(item);
        let newArr = [...authorsList];
        newArr[index][properties] = event.target.value; 
        setAuthorsList(newArr);

    }

    const handleRemove = (pIndex) => {
        setAuthorsList((currentArray) => 
            currentArray.filter((item, index) =>  index !== pIndex )
        );
    }

    const handleAddAuthor = () => {
        let newArr = [...authorsList];
        newArr.push({ "id": uuidv4(),"lastname":"","firstname":""})
        setAuthorsList(newArr);
    }

    const handleSelectAuthor = (newval, item) => {
        
        setAuthorsList((currentArray) => {
            let newArray = []
            for (let index = 0; index < currentArray.length; index++) {
                const element = currentArray[index];
                if (element === item) {
                    element.firstname = newval.firstname
                    element.lastname = newval.lastname
                    element.id = uuidv4();
                }
                newArray.push(element)
            }
                
            return newArray
            }
        );
    }

    return (
        <Grid item xs={12} md={6} >
            <FormLabel className={classes.formTitle} component="legend" style={{ border: "solid #C4C4C4 1px", borderRadius: "4px", padding: "5px" }}> Auteurs
            { authorsList.map((item,index) => (
                <Grid key={item.id} container alignItems="flex-start" spacing={2} style={{paddingTop:"5px"}}>
                        <Grid item xs={5}>
                        <Autocomplete
                            freeSolo
                            disabled={disabled}
                            defaultValue={item.lastname}
                            renderOption={(option) => {
                                return option.lastname + " " + option.firstname
                            }}
                            getOptionLabel={(option) => {
                                if (typeof option ==="string") {
                                    return option
                                } else {
                                    return option.lastname
                                }
                            }}
                            options={searchAuthorList}
                            onChange={(event, newval) => { handleSelectAuthor(newval, item)}}
                            renderInput={(params) => <TextField {...params}
                                size="small"
                                fullWidth
                                defaultValue={item.lastname }
                                label="Nom"
                                onChange={(event) => handleChange(event, item, "lastname")} 
                                />}
                        />
                        </Grid>
                        <Grid item xs={5}>
                        <TextField
                            disabled={disabled}
                                size="small"
                                fullWidth
                                defaultValue={item.firstname}
                            label="Prénom"
                            onChange={(event) => handleChange(event, item, "firstname")}
                            />  
                    </Grid>
                    <Grid item xs={2}>
                        <IconButton size="small" color="secondary" onClick={_ => handleRemove(index)} disabled={disabled}>
                            <RemoveCircleIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={10}>
                        <Button
                            disabled={disabled}
                            variant="contained"
                            color="primary"
                            size="small"
                            fullWidth
                            startIcon={<AddIcon />}
                            onClick={handleAddAuthor}
                        >
                            {/* Auteur */}
                        </Button>
                    </Grid>
                </Grid>
            </FormLabel>
        </Grid>
    )
}

export default AuthorsSelection
